import { createContext } from "react";

export const RadioGroupContext = createContext({name: undefined});